export interface IFileDownload {
  blob: Blob;
  filename: string;
}
